import type { ReactTable, RowData, TableState } from "@tanstack/react-table";
import { createContext, useContext } from "react";

import type { DataTableFeatures } from "./features";

type DataTableContextValue = {
  table: ReactTable<DataTableFeatures, Record<string, unknown>>;
  tableState: TableState<DataTableFeatures>;
};

export const DataTableContext = createContext<DataTableContextValue | null>(
  null,
);

export function useDataTableContext<TData extends RowData>(): ReactTable<
  DataTableFeatures,
  TData
> {
  const context = useContext(DataTableContext);

  if (!context) {
    throw new Error("useDataTableContext must be used within a DataTable");
  }

  return context.table as ReactTable<DataTableFeatures, TData>;
}
